export default __webpack_public_path__ + "static/media/15.d7738066.png";